var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 69,
    viewBox: "0 0 70 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6994 26.9962C42.1449 15.8781 23.4303 18.3247 20.7571 30.5386C19.1442 37.9086 25.9452 43.0663 26.8236 49.9679H42.4145C42.873 48.1224 43.8057 45.9276 44.4517 44.5786C45.7941 41.776 47.6929 39.944 48.4139 36.8173C49.0997 33.8423 49.0203 29.6407 47.6994 26.9962Z",
    stroke: "black",
    strokeWidth: 3.83333,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5379 59.3738C26.5335 57.2441 26.4289 55.1146 26.4659 52.9856C26.4806 52.1425 26.3365 51.1113 27.0662 50.5219C28.1316 49.6616 29.7164 49.5363 31.0387 49.5044C33.5169 49.4452 36.0142 49.466 38.495 49.4711C39.6248 49.473 41.3109 49.2769 42.3292 49.8383C43.2985 50.3716 43.5438 51.8256 43.6528 52.8076C43.8618 54.6893 44.4181 58.8913 42.8205 60.348C41.8143 61.2656 40.2448 61.4576 38.9563 61.6162C35.5382 62.0368 26.543 61.9533 26.5379 59.3738Z",
    stroke: "black",
    strokeWidth: 3.83333,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6478 61.7971C35.6757 62.9561 35.6893 64.1212 35.5981 65.2783",
    stroke: "black",
    strokeWidth: 3.83333,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61719 44.1053C9.83325 43.4635 11.1033 42.9355 12.3323 42.3215",
    stroke: "black",
    strokeWidth: 3.83333,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61719 19.1594C9.97464 20.0214 11.2732 20.974 12.6337 21.8286",
    stroke: "black",
    strokeWidth: 3.83333,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4064 8.94297C35.3586 7.23578 35.3692 5.54081 35.4237 3.83423",
    stroke: "black",
    strokeWidth: 3.83333,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4219 20.5722C58.126 19.4442 59.8809 18.3845 61.6142 17.3018",
    stroke: "black",
    strokeWidth: 3.83333,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4468 43.8337C54.7608 45.0114 56.0804 46.1753 57.3523 47.3988",
    stroke: "black",
    strokeWidth: 3.83333,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.5dde1c96d292cbeb23c2aea0a120ddd7.svg";
export { ForwardRef as ReactComponent };